import React from "react";
import { withRouter } from "react-router";
import { Image, Text } from "@sitecore-jss/sitecore-jss-react";

const ProcessorListing = ({ fields, location }) => {
  const params = new URLSearchParams(location.search);
  const deviceId = params.get("device-id") || null;
  const modelId = params.get("model-id") || null;

  const handleClick = (processorId) => {
    params.delete("sc_site"); // ssr param
    params.set("processor-id", processorId);

    const newUrl = new URL(
      deviceId && modelId
        ? fields.data.item.selectionNav.targetItem.featuresLink.url
        : fields.data.item.selectionNav.targetItem.changeDeviceLink.url,
      window.location.origin,
    );

    newUrl.search = params.toString();

    window.location.href = newUrl.toString();
  };

  return (
    <div className="processor-listing-container">
      <div className="processor-product-gallery-container">
        {fields.data.item.soundProcessorFolder.targetItem.children.map(
          (element) => {
            return (
              <div
                className="product-gallery-card"
                key={element.id}
                onClick={() => handleClick(element.id)}
              >
                <div className="product-gallery-image">
                  <Image field={element.image.jss} />
                </div>
                <div className="product-gallery-content">
                  <Text
                    className="product-gallery-name"
                    field={element.name}
                    tag="div"
                  />
                  <Text
                    className="product-gallery-details"
                    field={
                      element.subtitle.value
                        ? element.subtitle
                        : // temporary while per-element field is not available/not translated
                          fields.data.item.soundProcessorLabel
                    }
                    tag="div"
                  />
                </div>
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

export default withRouter(ProcessorListing);
